import React, { FC } from "react";
import { Col, Row } from "antd";
import PinUnpin from "@pages/member-details/pin-unpin-component";
// import { formatDate } from "@pages/utils/utils";
import { formatDisplayDate } from "@utils/helpers";
import CustomTooltip from "@pages/tool-tip";

const HedisGaps: FC<any> = (props) => {

  const genExtra = (id:any) => <PinUnpin marginRight={"0px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>;
  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  return (
    <>
      <Row className="title">
        <Col span={22}>{getHeading("HEDIS Gap")}</Col>
        <Col>
          {/* <span style={{ marginRight: "0px" }}>
            <img src={PushPin} alt="push-pin" />
          </span> */}
          {genExtra(props?.data?.datacardId)}
        </Col>
      </Row>

      {props?.data?.values?.map((hedisGaps:any, idx:number) => (
        <Row style={{ justifyContent: "space-between", display: "flex" }}>
          <Col span={18}>
            <span style={{ fontSize: "16px", color: "#5e6c84" }}>
              {hedisGaps?.insightDesc}
            </span>
          </Col>
          <Col span={6}>
            <Row>
              <span
                style={{
                  fontSize: "16px",
                  color: "#42526e",
                  fontWeight: "500",
                }}
              >
                {formatDisplayDate(hedisGaps?.insightModifyDate, "reminderDateActualFormat", "")}
              </span>
            </Row>
            <Row>
              <span style={{ fontSize: "13px", color: "#b3bac5" }}>
                {hedisGaps?.gapsInMonths} month(s) ago
              </span>
            </Row>
          </Col>
        </Row>
      ))}
    </>
  );
};

export default HedisGaps;
